<div class="auth-container sign-in-container">
  <h1 class="primary-font-semibold heading">
    {{ 'authentication.sign_in' | translate }}
  </h1>

  @if (errorMessage()) {
  <div class="error-message-container">
    <p class="error-message primary-font-medium form-description">
      {{ errorMessage() }}
    </p>
  </div>
  }

  <app-social-login-buttons [autoRedirectOnSocialLogin]="autoRedirectOnSocialLogin()"
    [postAuthRedirect]="postAuthRedirect()" [theme]="theme()" />

  <div class="or-container flex-center">
    <div class="or-line"></div>
    <span class="primary-font-semibold or-text">{{ 'authentication.or' | translate }}</span>
    <div class="or-line"></div>
  </div>

  <form [formGroup]="signInForm" class="form-container" (ngSubmit)="signIn().subscribe()" autocomplete="on"
    [appMarkFormTouched]="signInForm">
    <app-error-messages [control]="signInForm.controls.email" [errorKeyMapping]="fieldValidationRules().email">
      <div class="form-group">
        <label class="primary-font-medium form-label" for="email">{{
          'authentication.email' | translate
          }}</label>
        <input type="email" id="email" formControlName="email" class="form-input primary-font-medium"
          appErrorStateHighlight [errorStateControl]="signInForm.controls.email" errorStateClass="error-input"
          [placeholder]="'authentication.enter_your_email' | translate" />
      </div>
    </app-error-messages>

    <app-error-messages [control]="signInForm.controls.password" [errorKeyMapping]="fieldValidationRules().password">
      <div class="form-group">
        <label class="primary-font-medium form-label" for="password">{{
          'authentication.password' | translate
          }}</label>
        <div class="password-input-container">
          <app-password-input>
            <input id="password" formControlName="password" class="form-input primary-font-medium"
              appErrorStateHighlight [errorStateControl]="signInForm.controls.password" errorStateClass="error-input"
              [placeholder]="'authentication.enter_password' | translate" />
          </app-password-input>
        </div>
      </div>
    </app-error-messages>
    <button type="button" class="forgot-password-text primary-font-medium forgot-password-text default-button"
      [class.when-error-messages]="shouldShowValidationErrors" (click)="goToForgotPassword.emit()">
      {{ 'authentication.forgot_password' | translate }}
    </button>

    <button type="submit" class="auth-button primary-button custom-button rounded-pill primary-font-medium"
      [disabled]="signInForm.value.email === '' || signInForm.value.password === ''">
      @if (!isSubmitting()) {
      {{ 'authentication.sign_in_button' | translate }}
      } @else {
      <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      }
    </button>
  </form>

  <p class="primary-font-medium account-prompt">
    {{ 'authentication.do_not_have_account' | translate }}
    <button type="button" class="default-button" (click)="goToSignUp.emit()">
      {{ 'authentication.sign_up_button_text' | translate }}
    </button>
  </p>
</div>
